import React from 'react'
import { graphql, compose } from 'react-apollo'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, SelectInput } from '../../../UI'
import { ALL_LANGUAGES } from '../../../../constants'
import { validateRequired } from '../../../../libs/validation'

import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourLanguages.graphql'
import { NotificationManager } from 'react-notifications'

class LanguagesForm extends React.Component {
  componentWillMount() {
    this.setState({
      saving: false,
      error: ''
    })
    if (this.props.currentSteps.languages) {
      this.setState({
        items: this.props.currentSteps.languages.map(language => {
          return {
            id: _.uniqueId(),
            language: language
          }
        })
      })
    } else {
      this.setState({
        items: [
          {
            id: _.uniqueId(),
            language: null
          }
        ]
      })
    }
  }

  getLanguageOptions = () => {
    let options = ALL_LANGUAGES.map(e => {
      return {
        label: e['name'],
        value: e['1']
      }
    })
    return options
  }

  handleSubmit = values => {
    const { data, history, updateLocalTour, updateSteps } = this.props
    this.setState({
      saving: true,
      error: ''
    })

    const languages = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'language_') {
        if (languages.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: 'Each language must be chosen once'
          })
          return
        }
        languages.push(values[item])
      }
    }

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        languages: languages
      }
    })
      .then(() => {
        this.setState({
          saving: false
        })

        updateSteps()

        NotificationManager.success('Languages updated', 'Success', 5000)

        if (data.allLocalTours && data.allLocalTours[0]) {
          history.push(`/activity-steps/${data.allLocalTours[0].id}/category`)
        } else {
          history.push('/activity-steps/category')
        }
      })
      .catch(err => NotificationManager.error('Error while updating languages', 'Error', 5000))
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          language: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    const { t, loading } = this.props

    if (loading) {
      return <Loader showLoader={true} />
    }

    const { saving, items, error } = this.state
    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('languages')}</div>
        <div className="steps-screen__form-subtitle">{t('defines_languages')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {items.map((el, index) => {
                return (
                  <div key={index} className="removable-item-row">
                    <SelectInput
                      options={this.getLanguageOptions()}
                      id={`language_${el.id}`}
                      placeholder={t('select_language')}
                      initialValue={el.language}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                    />
                    {items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('main:remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {error && <small className="text-danger">{error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_language')}
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(LanguagesForm)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MainInfo/LanguagesForm.jsx